<template>
  <div id="login">
    <div class="login-box">
      <div class="login-title">百科数据资源库管理平台</div>
      <div class="form-box">
        <form id="login-form">
          <div class="login-input-box">
            <span class="left-label" style=" width:60px"
              ><span style="color: #f56c6c">*</span> 用户名</span
            >
            <input
              class="el-input__inner username"
              type="text"
              name="username"
              v-model="username"
              size="18"
              placeholder="请输入用户名"
              value=""
            />
            <div class="validate-msg validate-username">用户名不能为空</div>
          </div>
          <div class="login-input-box">
            <span class="left-label"
              ><span style="color: #f56c6c">*</span> 密码</span
            >
            <input
              class="el-input__inner password"
              type="password"
              name="password"
              v-model="password"
              size="19"
              placeholder="请输入密码"
              value=""
            />
            <div class="validate-msg validate-password">密码不能为空</div>
          </div>

          <!-- <div class="login-fail" th:if="${failMsg ne null}" th:text="${failMsg}"></div> -->
          <div class="login-fail"></div>
          <input
            class="submit-button button primary-button"
            style="margin-top: 15px"
            value="登录"
            @click="loginSubmit"
          />

          <!-- <span class="forget-password button">忘记密码</span> -->
        </form>
      </div>

      <div class="importData" v-if="$isSubLib == true">
        <el-upload
          class="upload-demo"
          action="/zyk/api/token/importSubLibData"
          :headers="headers"
          :file-list="fileList"
          accept=".zip"
          name="upfile"
        >
          <el-button slot="trigger" type="primary" style="margin-right: 8px"
            >选择文件</el-button
          >
          <el-button type="success" @click="submitUpload">上传并导入</el-button>
          <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
        </el-upload>
      </div>
    </div>
    <div class="forget-dialog">
      <div class="dialog-msg">请联系技术部门，电话：88391111。</div>
      <div class="forget-password-close button primary-button">关 闭</div>
    </div>
    <!-- <div v-if="isLib">按钮</div> -->
    <div style="text-align: center">
      <a
        href="https://81.zgbk.com/aboutUS/"
        target="_blank"
        style="font-size: 24px; font-weight: 700; color: #2aafda"
        >关于我们</a
      >
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";

export default {
  data() {
    return {
      username: "",
      password: "",
      getCatelog: {},
      fileList: [], //上传文件列表
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
    };
  },
  mounted() {
    document.addEventListener("keypress", this.handleKeyPress);
  },
  methods: {
    loginSubmit() {
      var params = {
        username: this.username,
        password: this.password,
      };
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/login",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (data) {
          if (data.code == 200) {
            cookies.set("userName", data.obj.user.realName);
            cookies.set("token", data.obj.token);
            localStorage.setItem("catalog", JSON.stringify(data.obj.catalog));
            // // cookies.set("catalog", data.obj.catalog);
            // that.getCatelog = data.obj.catalog;
            // console.log(that.getCatelog);
            window.location.href = "/fullSearch";
          } else {
            alert(data.msg);
          }
        },
        error: function () {
          console.log("失败了");
        },
      });
    },
    handleKeyPress(event) {
      const { keyCode } = event;
      if (keyCode == 13) {
        this.loginSubmit(); // 登录方法
      }
    },
    beforeDestroy() {
      document.removeEventListener("keypress", this.handleKeyPress); // 移除事件监听器
    },
  },
};
</script>

<style>
#login {
  height: 100vh;
  min-height: 100%;
  background: url("../../img/login.jpg");
  background-size: cover;
  overflow: hidden;
}
.login-box {
  display: inline-box;
  width: 600px;
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  margin: 150px auto 100px;
  background: #fff;
  text-align: center;
  padding: 0 140px 50px;
  box-sizing: border-box;
}
.login-box .el-form-item__label {
  text-align: left;
}
.login-title {
  font-size: 24px;
  font-weight: 700;
  color: #2aafda;
  line-height: 145px;
}
.login-input-box {
  line-height: 40px;
  font-size: 14px;
  color: #555;
  position: relative;
}
.login-input-box .el-input__inner {
  width: 200px;
  margin-left: 30px;
  margin-bottom: 20px;
}
.login-input-box .left-label {
  display: inline-block;
  width: 60px;
  text-align: left;
}
.form-box {
  position: relative;
}
.login-fail {
  position: absolute;
  width: 280px;
  display: inline-block;
  color: red;
  border-radius: 4px;
  line-height: 40px;
  height: 40px;
  left: 102px;
  bottom: 32px;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
}
.button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.primary-button {
  color: #fff;
  background: #50b58d;
  border-color: #50b58d;
}
.primary-button:focus,
.primary-button:hover {
  background: #419674;
  border-color: #419674;
}
.forget-password:focus,
.forget-password:hover {
  background: #f1f1f1;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.forget-password-close {
  margin-top: 30px;
}
.forget-dialog {
  display: none;
  position: absolute;
  top: 250px;
  left: 50%;
  margin-left: -200px;
  width: 400px;
  padding: 30px 0 22px;
  background: #fff;
  text-align: center;
  height: 100px;
  border: 1px solid #dbdbdb;
  border-radius: 10px;
}
.time-out {
  display: none;
}
.login-input-box .el-input__inner.vrCode {
  width: 102px;
}
.get-code-button {
  display: inline-block;
  width: 97px;
  padding: 11px 1px;
  text-align: center;
}
.validate-msg {
  position: absolute;
  color: red;
  top: 32px;
  left: 103px;
  display: none;
}
.importData {
  margin-top: 20px;
}
</style>